import { render } from "./SupervisionSidebar.vue?vue&type=template&id=13dd1bfa"
import script from "./SupervisionSidebar.vue?vue&type=script&lang=js"
export * from "./SupervisionSidebar.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SupervisionSidebar.vue?vue&type=style&index=0&id=13dd1bfa&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__